import React, { useEffect } from 'react';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import Card, { CardTitle } from '../Card';
import Button from '../Button';

// Rendered by the router for unknown URLs (404) and for any render/loader error thrown by a page,
// so a single bad record shows this screen instead of a blank white page. Deliberately standalone
// (no Sidebar/Header) so it still renders if the crash came from the layout itself.
const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  const isNotFound = isRouteErrorResponse(error) && error.status === 404;

  useEffect(() => {
    if (error && !isNotFound) console.error('Page crashed:', error);
  }, [error, isNotFound]);

  const title = isNotFound ? 'Page not found' : 'Something went wrong';
  const message = isNotFound
    ? "The page you're looking for doesn't exist or has been moved."
    : 'This page ran into an unexpected error. Try reloading, or head back to the dashboard.';

  return (
    <div className="flex min-h-screen items-center justify-center px-4 text-white" style={{ background: 'black' }}>
      <Card className="w-full max-w-lg !p-8">
        <p className="text-6xl font-extrabold text-[#C72727]">{isNotFound ? '404' : 'Oops'}</p>
        <div className="mt-4">
          <CardTitle title={title} />
        </div>
        <p className="mt-2 text-sm text-gray-400">{message}</p>
        <div className="mt-8 flex flex-wrap items-center gap-4">
          <Button label="Go to Dashboard" onClick={() => navigate('/')} />
          {!isNotFound && (
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="h-[60px] rounded-[30px] border border-[#474646] px-[30px] text-sm font-bold text-white hover:bg-[#2a2a2a]"
            >
              Reload Page
            </button>
          )}
        </div>
      </Card>
    </div>
  );
};

export default ErrorPage;
